import React, { useEffect, useState } from "react";
import {
  IdentificationIcon,
  MinusIcon,
  UserCircleIcon,
  PlusIcon,
  TrashIcon,
  ShoppingCartIcon,
} from "@heroicons/react/outline";
import img from "../assets/product-img.png";
import { ChevronBarExpand, ChevronDown, PencilSquare, Plus, Trash, X } from "react-bootstrap-icons";
import Popup from "../Controllers/Popup";
import PaymentDetails from "../Controllers/PaymentDetails";
import { useDispatch, useSelector } from "react-redux";
import { addToCartProduct } from "../Redux/Action/catelog.action";
import { FormatAmount, formatDate, GetCurrencySymbol } from "../Controllers/FormatAmount";
import { getAllCustomers } from "../Redux/Action/customer.action";
import { Autocomplete, Badge, Box, Menu, MenuItem, TextField, Tooltip } from "@mui/material";
import {
  addDiscount,
  applyDiscount,
  deletePendingOrder,
  getAllDiscount,
  getTransactions,
  placeOrder,
  removeDiscount,
} from "../Redux/Action/order.action";
import AddCustomer from "../Controllers/AddCustomer";
import ConfirmationPopUp from "../Controllers/ConfirmationPopUp";
import EditCustomer from "../Controllers/EditCustomer";
import NO_PHOTO from "../assets/nophoto.png";
import { getInstalledExtensions } from "../Redux/Action/extensions.action";
const OrderDetails = ({ handleCloseOrderDetail }) => {
  const dispatch = useDispatch();
  const [isPaymentDetail, setPaymentDetail] = useState(false);
  const [openCustomerPopup, setOpenCustomerPopup] = useState(false);
  const [openCustPopup, setOpenCustPopup] = useState(false);
  const [editData, setEditData] = useState();
  const [isSuccess, setIsSuccess] = useState(false);
  const { staffInfo, currency } = useSelector((state) => state.authReducer);
  const currencyRate =
    currency &&
    (currency?.find((c) => c.name === staffInfo?.client?.currency_format)?.rate[0] ?? 1);
  const { atcProduct, allProducts } = useSelector((state) => state.catelogReducer);
  const { allCustomers } = useSelector((state) => state.customerReducer);
  const { allDiscount, discountInfo, transactions } = useSelector((state) => state.orderReducer);
  const [discountType, setDiscountType] = useState(atcProduct?.adjust_discount_type ?? "");
  const [selectCustomer, setSelectCustomer] = useState("");
  const [selectCoupon, setSelectCoupon] = useState("");
  const [search, setSearch] = useState("");
  const [couponSearch, setCouponSearch] = useState("");
  const [expand, setExpand] = useState(false);
  const [adjustDiscount, setAdjustDiscount] = useState(
    atcProduct?.adjust_discount_percentage > 0
      ? atcProduct?.adjust_discount_percentage
      : (atcProduct?.adjust_discount * currencyRate ?? ""),
  );
  const location_id = localStorage.getItem("location_id");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const sortedData = atcProduct && [...atcProduct?.products].reverse();
  const discountData =
    allDiscount?.data?.records && !atcProduct?.total_discount > 0 ? allDiscount?.data?.records : [];
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closePendingMenu = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    dispatch(getInstalledExtensions("Razorpay"));
  }, [])
  const handlePendingOrder = (elem) => {
    const discountData =
      allDiscount?.data?.records?.find((discount) => discount?._id === elem?.discount) || null;
    const data = {
      data: {
        _id: discountData?._id,
        discount: discountData?.discount,
        discount_Type: discountData?.discount_Type,
        coupon_code: discountData?.coupon_code,
      },
    };
    if (data) {
      dispatch(addDiscount(data));
    }
    let cart = {
      products: [],
      status: "completed",
      channel: "pos",
      total_price: 0,
      sub_total: 0,
      adjust_discount: 0,
      adjust_discount_percentage: 0,
      adjust_discount_type: "amount",
    };

    cart.products = elem?.products;

    const calculateTotalPrice = (products) =>
      products.reduce((total, product) => total + product?.selling_price * product?.quantity, 0);

    const total_price = calculateTotalPrice(elem.products);
    const calculateMembershipDiscount = () => {
      if (!elem?.pos_membership) {
        return 0;
      } else if (new Date(elem?.user?.expire_date) >= new Date()) {
        const membershipType = elem?.pos_membership?.product_discount_type;
        const membershipValue = elem?.pos_membership?.discount_value;
        if (membershipType === "percentage") {
          return total_price * (membershipValue / 100);
        } else if (membershipType === "amount") {
          return membershipValue / currencyRate;
        }
      }
      return 0;
    };
    const membershipDiscount = calculateMembershipDiscount();
    cart._id = elem?._id;
    cart.pos_location = elem?.pos_location;
    cart.discount = elem?.discount;
    cart.pos_customer = elem?.pos_customer;
    cart.total_price = elem?.total_price;
    cart.sub_total = total_price;
    cart.total_discount = elem?.total_discount;
    cart.adjust_discount_percentage = elem?.adjust_discount_percentage || 0;
    cart.adjust_discount = elem?.adjust_discount || 0;
    cart.adjust_discount_type = elem?.adjust_discount_type || "amount";
    cart.pos_membership_discount_type = elem?.pos_membership?.product_discount_type || "amount";
    cart.pos_membership = elem?.pos_membership?._id;
    cart.pos_membership_discount = membershipDiscount;
    cart.pos_membership_product = elem?.pos_membership?.product_name;
    if (elem?.pos_membership?.product_discount_type === "percentage") {
      cart.pos_membership_discount_percentage = elem?.pos_membership?.discount_value;
    }

    localStorage.setItem("addToCart", JSON.stringify(cart));
    dispatch(addToCartProduct(cart));
    setAnchorEl(null);
  };
  const handleClosePopup = () => {
    setPaymentDetail(false);
  };
  const closeCustomerPopup = () => {
    setOpenCustomerPopup(false);
  };
  const closeCustPopup = () => {
    setOpenCustPopup(false);
  };
  const qtyCounter = (data, increment) => {
    if (!data) return;

    // Retrieve the cart from localStorage or initialize a default cart
    const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
      products: [],
      status: "completed",
      channel: "pos",
      pos_location: location_id,
      total_price: 0,
      product_discount: [],
      sub_total: 0,
      total_discount: 0,
      adjust_discount: 0,
      adjust_discount_type: "amount",
    };

    const calculateTotalPrice = (products) =>
      products.reduce((total, product) => total + product.selling_price * product.quantity, 0);

    const calculateProductTotalDiscount = (product) => {
      if (!product.product_discount || product.product_discount.length === 0) {
        return 0;
      }

      return product.product_discount.reduce((totalDiscount, elem) => {
        const productQuantity = product?.quantity || 0;

        const isEligible =
          new Date(elem?.start_date) <= new Date() &&
          new Date(elem?.end_date) >= new Date() &&
          elem?.quantity <= productQuantity;

        if (isEligible) {
          if (elem?.product_discount_type === "percentage") {
            const discountValue =
              (product.selling_price * productQuantity * elem?.discount_value) / 100;
            return totalDiscount + discountValue;
          } else if (elem?.product_discount_type === "amount") {
            return totalDiscount + elem?.discount_value;
          }
        }

        return totalDiscount;
      }, 0);
    };

    const updatedProducts = cart.products.map((product) => {
      if (product.product === data.product) {
        const newQuantity = increment ? product.quantity + 1 : Math.max(product.quantity - 1, 1);
        const productTotalDiscount = calculateProductTotalDiscount({
          ...product,
          quantity: newQuantity,
        });
        const discountAmount = newQuantity > 0 ? productTotalDiscount / newQuantity : 0;
        return {
          ...product,
          quantity: newQuantity,
          product_total: data?.selling_price * newQuantity,
          product_total_discount: productTotalDiscount,
          discount_amount: discountAmount,
        };
      }
      return product;
    });

    const total_price = calculateTotalPrice(updatedProducts);

    const calculateTotalDiscount = () => {
      if (!discountInfo || !discountInfo.data) {
        return 0;
      }

      const discountType = discountInfo.data.discount_Type;
      const discountValue = discountInfo.data.discount;

      if (discountType === "percentage") {
        return total_price * (discountValue / 100);
      } else if (discountType === "amount") {
        return discountValue / currencyRate;
      }

      return 0;
    };

    const discount = calculateTotalDiscount();
    const calculateAdjustDiscount = (currentTotalPrice) => {
      if (cart.adjust_discount_type === "percentage") {
        return currentTotalPrice * (cart.adjust_discount_percentage / 100);
      } else if (cart.adjust_discount_type === "amount") {
        return cart.adjust_discount / currencyRate;
      }
      return 0;
    };

    const adjustDiscount = calculateAdjustDiscount(total_price - discount);
    const product_total_discount = updatedProducts.reduce(
      (total, product) => total + (product.product_total_discount || 0),
      0,
    );

    const calculateMembershipDiscount = () => {
      if (!cart?.pos_membership) {
        return 0;
      }
      const membershipType = cart?.pos_membership_discount_type;
      const membershipValue = cart?.pos_membership_discount;
      if (membershipType === "percentage") {
        return (
          (total_price - product_total_discount) * (cart?.pos_membership_discount_percentage / 100)
        );
      } else if (membershipType === "amount") {
        return membershipValue / currencyRate;
      }

      return 0;
    };
    const membershipDiscount = calculateMembershipDiscount();
    const updatedCart = {
      ...cart,
      products: updatedProducts,
      total_price:
        total_price - discount - product_total_discount - adjustDiscount - membershipDiscount,
      sub_total: total_price - product_total_discount,
      product_total_discount: product_total_discount,
      total_discount: discount,
      adjust_discount: adjustDiscount,
      pos_membership_discount: membershipDiscount,
    };
    localStorage.setItem("addToCart", JSON.stringify(updatedCart));
    dispatch(addToCartProduct(updatedCart));
  };
  const updateProductQuantity = (productData, newQuantity) => {
    if (!productData) return;
    const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
      products: [],
      status: "completed",
      channel: "pos",
      pos_location: location_id,
      total_price: 0,
      product_discount: [],
      sub_total: 0,
      total_discount: 0,
      adjust_discount: 0,
      adjust_discount_type: "amount",
    };

    const calculateTotalPrice = (products) =>
      products.reduce((total, product) => total + product.selling_price * product.quantity, 0);

    const calculateProductTotalDiscount = (product) => {
      if (!product.product_discount || product.product_discount.length === 0) {
        return 0;
      }

      return product.product_discount.reduce((totalDiscount, elem) => {
        const productQuantity = product?.quantity || 0;

        const isEligible =
          new Date(elem?.start_date) <= new Date() &&
          new Date(elem?.end_date) >= new Date() &&
          elem?.quantity <= productQuantity;

        if (isEligible) {
          if (elem?.product_discount_type === "percentage") {
            const discountValue =
              (product.selling_price * productQuantity * elem?.discount_value) / 100;
            return totalDiscount + discountValue;
          } else if (elem?.product_discount_type === "amount") {
            return totalDiscount + elem?.discount_value;
          }
        }

        return totalDiscount;
      }, 0);
    };

    const updatedProducts = cart.products.map((product) => {
      if (product.product === productData.product) {
        const totalQuantity = product.total_quantity;
        const validatedQuantity = Math.max(1, Math.min(newQuantity, totalQuantity));

        const productTotalDiscount = calculateProductTotalDiscount({
          ...product,
          quantity: validatedQuantity,
        });
        const discountAmount = validatedQuantity > 0 ? productTotalDiscount / validatedQuantity : 0;

        return {
          ...product,
          quantity: validatedQuantity,
          product_total: productData?.selling_price * validatedQuantity,
          product_total_discount: productTotalDiscount,
          discount_amount: discountAmount,
        };
      }
      return product;
    });

    const total_price = calculateTotalPrice(updatedProducts);

    const calculateTotalDiscount = () => {
      if (!discountInfo || !discountInfo.data) {
        return 0;
      }

      const discountType = discountInfo.data.discount_Type;
      const discountValue = discountInfo.data.discount;

      if (discountType === "percentage") {
        return total_price * (discountValue / 100);
      } else if (discountType === "amount") {
        return discountValue / currencyRate;
      }

      return 0;
    };

    const discount = calculateTotalDiscount();

    const calculateAdjustDiscount = (currentTotalPrice) => {
      if (cart.adjust_discount_type === "percentage") {
        return currentTotalPrice * (cart.adjust_discount_percentage / 100);
      } else if (cart.adjust_discount_type === "amount") {
        return cart.adjust_discount / currencyRate;
      }
      return 0;
    };

    const adjustDiscount = calculateAdjustDiscount(total_price - discount);
    const product_total_discount = updatedProducts.reduce(
      (total, product) => total + (product.product_total_discount || 0),
      0,
    );

    const calculateMembershipDiscount = () => {
      if (!cart?.pos_membership) {
        return 0;
      }
      const membershipType = cart?.pos_membership_discount_type;
      const membershipValue = cart?.pos_membership_discount;
      if (membershipType === "percentage") {
        return (
          (total_price - product_total_discount) * (cart?.pos_membership_discount_percentage / 100)
        );
      } else if (membershipType === "amount") {
        return membershipValue / currencyRate;
      }

      return 0;
    };

    const membershipDiscount = calculateMembershipDiscount();

    const updatedCart = {
      ...cart,
      products: updatedProducts,
      total_price:
        total_price - discount - product_total_discount - adjustDiscount - membershipDiscount,
      sub_total: total_price - product_total_discount,
      product_total_discount: product_total_discount,
      total_discount: discount,
      adjust_discount: adjustDiscount,
      pos_membership_discount: membershipDiscount,
    };

    localStorage.setItem("addToCart", JSON.stringify(updatedCart));
    dispatch(addToCartProduct(updatedCart));
  };

  const removeATCProduct = (id, varId) => {
    const calculateTotalPrice = (products) =>
      products.reduce((total, product) => total + product.selling_price * product.quantity, 0);

    const calculateTotalDiscount = (total_price) => {
      const discountType = discountInfo?.data?.discount_Type;
      const discountValue = discountInfo?.data?.discount;

      if (discountType === "percentage") {
        return total_price * (discountValue / 100);
      } else if (discountType === "amount") {
        return discountValue / currencyRate;
      }
      return 0;
    };

    if (id === true) {
      // Clear the cart completely if id is true
      const emptyCart = {
        products: [],
        status: "completed",
        channel: "pos",
        pos_location: location_id,
        total_price: 0,
        sub_total: 0,
        total_discount: 0,
      };
      localStorage.setItem("addToCart", JSON.stringify(emptyCart));
      dispatch(addToCartProduct(emptyCart));
      dispatch(removeDiscount());
      setSelectCustomer("");
      setSelectCoupon("");
    } else {
      let cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
        products: [],
        status: "completed",
        channel: "pos",
        pos_location: location_id,
        total_price: 0,
        sub_total: 0,
      };

      // Remove the specific product variant (or product if no variant is passed)
      const updatedProducts = cart.products.filter((product) => {
        if (varId === undefined) {
          return product.product !== id; // Match only on product ID
        }
        return !(product.product === id && product.variant === varId); // Match on both product ID and variant ID
      });

      let updatedCart;
      if (updatedProducts.length < 1) {
        // If no products are left, reset the cart and membership discount
        const {
          pos_membership_discount,
          adjust_discount,
          discount,
          coupon_code,
          total_discount,
          ...restOfCart
        } = cart;
        updatedCart = {
          ...restOfCart,
          products: [],
          total_price: 0,
          sub_total: 0,
          total_discount: 0,
          pos_membership_discount:
            cart?.pos_membership_discount_type === "percentage" ? 0 : pos_membership_discount,
        };
        setSelectCustomer("");
        setSelectCoupon("");
        dispatch(removeDiscount());
      } else {
        const calculateAdjustDiscount = (currentTotalPrice) => {
          const adjustDiscountType = cart.adjust_discount_type;
          const adjustDiscountValue = cart.adjust_discount;

          if (adjustDiscountType === "percentage") {
            return currentTotalPrice * (cart?.adjust_discount_percentage / 100); // Percentage based discount
          } else if (adjustDiscountType === "amount") {
            return adjustDiscountValue / currencyRate; // Fixed amount discount
          }

          return 0;
        };

        const total_price = calculateTotalPrice(updatedProducts);
        const discount = calculateTotalDiscount(total_price);
        const adjustDiscount = calculateAdjustDiscount(total_price - discount);
        const calculateMembershipDiscount = () => {
          if (!cart?.pos_membership) {
            return 0;
          }
          const membershipType = cart?.pos_membership_discount_type;
          const membershipValue = cart?.pos_membership_discount;
          if (membershipType === "percentage") {
            return total_price * (cart?.pos_membership_discount_percentage / 100);
          } else if (membershipType === "amount") {
            return membershipValue / currencyRate;
          }

          return 0;
        };
        const membershipDiscount = calculateMembershipDiscount();
        updatedCart = {
          ...cart,
          products: updatedProducts,
          total_price: total_price - discount - adjustDiscount - membershipDiscount,
          sub_total: total_price,
          adjust_discount: adjustDiscount,
          total_discount: discount,
          pos_membership_discount: membershipDiscount,
        };
      }

      // Update cart in localStorage
      localStorage.setItem("addToCart", JSON.stringify(updatedCart));

      dispatch(addToCartProduct(updatedCart));
    }
    setIsClose(false);
  };
  useEffect(() => {
    dispatch(getTransactions("pending"));
  }, []);
  const filterOptionsForCustomers = (options, { inputValue }) => {
    const normalizedInputValue = inputValue.toLowerCase();
    if (normalizedInputValue?.length < 3) {
      return []; // No options displayed until at least 3 characters are entered
    }
    return options?.filter((option) => {
      const combinedFields = `${option?.name?.toLowerCase() || ""} ${option?.phone?.toLowerCase() || ""} ${option?.email?.toLowerCase() || ""}`;
      return combinedFields.includes(normalizedInputValue);
    });
  };
  const handleCustomer = (e, v) => {
    const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
      products: [],
      status: "completed",
      channel: "pos",
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
    };

    let updateCart;

    if (!v?._id) {
      if (cart?.pos_membership_discount) {
        const {
          pos_customer,
          customer_phone,
          pos_membership_discount_type,
          pos_membership_discount_percentage,
          pos_membership_product,
          pos_membership_discount,
          pos_membership,
          ...restOfCart
        } = cart;
        updateCart = {
          ...restOfCart,
          total_price: cart?.total_price + pos_membership_discount,
        };
      } else {
        const { pos_customer, customer_phone, ...restOfCart } = cart;
        updateCart = {
          ...restOfCart,
        };
      }
      setSelectCustomer("");
    } else {
      setSelectCustomer(v?._id);
      if (v?.pos_membership && new Date(v?.expire_date) >= new Date()) {
        const calculateMembershipDiscount = () => {
          if (!v?.pos_membership) {
            return 0;
          }
          const membershipType = v?.pos_membership.product_discount_type;
          const membershipValue = v?.pos_membership.discount_value;

          if (membershipType === "percentage") {
            return cart?.sub_total * (membershipValue / 100);
          } else if (membershipType === "amount") {
            return membershipValue / currencyRate;
          }

          return 0;
        };
        const membershipDisc = calculateMembershipDiscount();
        updateCart = {
          ...cart,
          pos_customer: v?._id,
          customer_phone: v?.phone,
          pos_membership: v?.pos_membership?._id,
          pos_membership_product: v?.product_name,
          total_price: cart?.total_price - membershipDisc,
          pos_membership_discount: membershipDisc,
          ...(v?.pos_membership?.product_discount_type === "percentage" && {
            pos_membership_discount_percentage: v?.pos_membership.discount_value,
          }),
          pos_membership_discount_type: v?.pos_membership?.product_discount_type,
        };
      } else {
        updateCart = {
          ...cart,
          pos_customer: v?._id,
          customer_phone: v?.phone,
        };
      }
    }

    localStorage.setItem("addToCart", JSON.stringify(updateCart));
    dispatch(addToCartProduct(updateCart));
  };
  useEffect(() => {
    if (search === "" || search?.length > 2) {
      dispatch(getAllCustomers(search));
    }
  }, [search]);
  const handleDiscount = (e, v) => {
    const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
      products: [],
      status: "completed",
      channel: "pos",
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
    };

    let updateCart;

    if (!v?.coupon_code) {
      const { total_discount, coupon_code, discount, ...restOfCart } = cart;
      updateCart = {
        ...restOfCart,
        total_price:
          cart?.sub_total - (cart?.adjust_discount || 0) - (cart?.pos_membership_discount || 0),
      };
      setSelectCoupon("");
      localStorage.setItem("addToCart", JSON.stringify(updateCart));
      dispatch(addToCartProduct(updateCart));
      dispatch(removeDiscount());
    } else {
      setSelectCoupon(v?.coupon_code);
    }
  };
  const discountOff = (e) => {
    // Retrieve the cart from localStorage or initialize a default cart
    const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
      products: [],
      status: "completed",
      channel: "pos",
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
      total_discount: 0,
      adjust_discount: 0,
      adjust_discount_type: discountType,
    };
    // Get the discount value from the input, defaulting to 0 if empty or NaN
    let discountValue = parseFloat(e.target.value) || 0;
    setAdjustDiscount(e.target.value);
    // Calculate percentage discount if applicable
    if (discountValue > 0 && discountType === "percentage") {
      discountValue = (cart.sub_total - (cart.total_discount || 0)) * (discountValue / 100);
    } else if (discountValue > 0 && discountType === "amount") {
      discountValue = discountValue / currencyRate;
    }
    let updateCart;

    // If discount input is cleared or 0, reset the discount and total price
    if (discountValue === 0) {
      updateCart = {
        ...cart,
        total_price: cart.sub_total - cart.total_discount || cart.sub_total, // Reset to sub_total minus total_discount
        adjust_discount: 0, // Remove the applied discount
      };
    } else {
      // Apply the discount if it's valid (greater than 0 and less than the original total price)
      if (discountValue > 0 && discountValue < cart.total_price) {
        updateCart = {
          ...cart,
          total_price: cart?.sub_total - (cart?.total_discount || 0) - discountValue, // Subtract discount from original total price
          adjust_discount: discountValue, // Track the applied discount
          adjust_discount_percentage: discountType === "percentage" ? Number(e.target.value) : 0, // Track the applied discount
        };
      } else {
        // Fallback when the discount is invalid (too large or negative)
        updateCart = {
          ...cart,
          total_price: cart.sub_total - cart.total_discount || cart.sub_total, // Reset to sub_total minus total_discount
          adjust_discount: 0, // Reset discount
        };
        cart.originalTotalPrice = 0; // Reset original total price if fallback is triggered
        setAdjustDiscount(0);
      }
    }

    // Save the updated cart to localStorage and update the state
    localStorage.setItem("addToCart", JSON.stringify(updateCart));
    dispatch(addToCartProduct(updateCart));
  };
  const handleDiscountType = (e) => {
    setDiscountType(e.target.value);
    setAdjustDiscount("");
    const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
      products: [],
      status: "completed",
      channel: "pos",
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
      total_discount: 0,
      adjust_discount: 0,
    };
    let updateCart;
    const { adjust_discount_percentage, ...restOfCart } = cart;
    updateCart = {
      ...restOfCart,
      total_price: cart?.sub_total - cart?.total_discount || 0,
      adjust_discount: 0,
      adjust_discount_type: e.target.value,
    };
    localStorage.setItem("addToCart", JSON.stringify(updateCart));
    dispatch(addToCartProduct(updateCart));
  };

  useEffect(() => {
    if (atcProduct?.pos_customer) {
      setSelectCustomer(atcProduct?.pos_customer);
    }
    if (atcProduct?.coupon_code) {
      setSelectCoupon(atcProduct?.coupon_code);
    }
  }, [atcProduct]);
  useEffect(() => {
    const products = atcProduct?.products?.map((product) => product?.product);
    const categoryProduct = allProducts?.data?.records?.filter((x) =>
      products?.some((product) => product === x._id),
    );
    const categories = categoryProduct?.flatMap((category) =>
      category?.categories?.map((cat) => cat?._id),
    );
    if (selectCustomer && products && categories) {
      dispatch(getAllDiscount(selectCustomer, products, categories));
    }
  }, [atcProduct, selectCustomer]);
  useEffect(() => {
    if (discountInfo?.data?.coupon_code) {
      const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
        products: [],
        status: "completed",
        channel: "pos",
        pos_location: location_id,
        total_price: 0,
        sub_total: 0,
      };
      if (!cart.coupon_code) {
        let updatedCart = { ...cart };
        let discount = 0;

        if (cart?.total_price > 0) {
          if (discountInfo?.data?.discount_Type === "percentage") {
            discount = (cart.sub_total * discountInfo?.data?.discount) / 100;
            updatedCart.total_price = cart.total_price - discount;
          } else {
            discount = discountInfo?.data?.discount / currencyRate;
            updatedCart.total_price = cart.total_price - discount;
          }

          const calculateAdjustDiscount = (currentTotalPrice) => {
            const adjustDiscountType = cart.adjust_discount_type;
            const adjustDiscountValue = cart.adjust_discount;
            if (adjustDiscountType === "percentage") {
              return currentTotalPrice * (cart?.adjust_discount_percentage / 100); // Percentage-based discount
            } else if (adjustDiscountType === "amount") {
              return adjustDiscountValue / currencyRate; // Fixed amount discount
            }

            return 0;
          };

          const adjustDiscount = calculateAdjustDiscount(cart?.total_price - discount);

          updatedCart = {
            ...updatedCart,
            discount: discountInfo?.data?._id,
            coupon_code: discountInfo?.data?.coupon_code,
            total_discount: discount,
            adjust_discount: adjustDiscount,
            cash_amount: updatedCart.total_price,
          };
        }

        localStorage.setItem("addToCart", JSON.stringify(updatedCart));
        dispatch(addToCartProduct(updatedCart));
      }
    }
  }, [discountInfo]);
  const orderPanding = () => {
    const cart = JSON.parse(localStorage.getItem("addToCart"));
    if (cart?.products?.length > 0) {
      const updateCart = {
        ...cart,
        status: "pending",
      };
      dispatch(placeOrder(updateCart));
      handleClosePopup();
    } else {
      return;
    }
  };
  const payNow = () => {
    setPaymentDetail(true);
    const cart = JSON.parse(localStorage.getItem("addToCart"));
    let taxableAmount = 0;
    let goodsValueTotal = 0;
    for (const product of cart?.products) {
      const tax = product?.cgst + product?.sgst;
      const goodsValue = product?.product_total / (1 + tax / 100);
      taxableAmount = taxableAmount + product?.product_total - goodsValue;
      goodsValueTotal = goodsValueTotal + goodsValue;
    }
    const updateCart = {
      ...cart,
      goodsValue: goodsValueTotal,
      tax_amount: taxableAmount,
      cash_amount: cart.total_price,
    };
    localStorage.setItem("addToCart", JSON.stringify(updateCart));
    dispatch(addToCartProduct(updateCart));
  };
  const [isClose, setIsClose] = useState(false);
  const closePopupClearCart = () => {
    setIsClose(false);
  };
  const runFunctionClearCart = () => {
    removeATCProduct(true);
  };
  return (
    <>
      <div className="space-y-4 p-5">
        <div className="flex items-center justify-between">
          <h4>Order Details</h4>
          {transactions?.data?.records?.length > 0 && (
            <Tooltip title="Draft Order">
              <button
                className="block"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <Badge badgeContent={transactions?.data?.records?.length} color="primary">
                  <ShoppingCartIcon className="w-[20px] h-[20px] " />
                </Badge>
              </button>
            </Tooltip>
          )}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={closePendingMenu}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {transactions?.data?.records &&
              transactions?.data?.records?.map((elem, index) => (
                <MenuItem
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePendingOrder(elem);
                  }}
                >
                  <div className="flex flex-col justify-between">
                    <div className="flex items-center space-x-20">
                      <UserCircleIcon className="w-5 h-5" />
                      &nbsp;{`${elem?.user?.name} #${elem?.order_id}`}
                      <Trash
                        className="flex items-center cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(deletePendingOrder(elem?._id));
                        }}
                      />
                    </div>
                    <div>
                      {`${elem?.products?.reduce((total, product) => total + product.quantity, 0)} Items  Total: ${FormatAmount(elem?.total_price, staffInfo?.client)}`}
                    </div>
                  </div>
                </MenuItem>
              ))}
          </Menu>
          <button className="close-btn block lg:hidden" onClick={() => handleCloseOrderDetail()}>
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-[16px] block font-medium">Customer Information</span>
          <button
            type="button"
            className="flex items-center"
            onClick={() => setOpenCustomerPopup(true)}
          >
            <Plus /> Add Customer
          </button>
        </div>
        <div className="relative input">
          <Autocomplete
            className="autocomplete"
            options={allCustomers?.records ?? []}
            getOptionLabel={(options) => options?.name}
            filterOptions={filterOptionsForCustomers}
            value={allCustomers?.records?.find((x) => x._id === atcProduct?.pos_customer) ?? null}
            noOptionsText={
              allCustomers?.records?.length > 0 && !search
                ? "Please enter at least 3 characters"
                : "Not found"
            }
            onChange={handleCustomer}
            renderOption={(props, option) => (
              <Box key={option.code} component="li" {...props}>
                <div className="flex items-center justify-between space-x-56">
                  <div>
                    <p className="flex items-center text-sm gap-1">
                      <UserCircleIcon className="w-5 h-5" /> {option.name}
                    </p>
                    {option.phone && <p className="text-sm">{option.phone}</p>}
                    {option.email && <p className="text-sm">{option.email}</p>}
                  </div>
                  <PencilSquare
                    className="flex items-center justify-end cursor-pointer w-5 h-5 "
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenCustPopup(true);
                      setEditData(option);
                    }}
                  />
                </div>
              </Box>
            )}
            renderInput={(brands) => (
              <TextField
                placeholder="Select Customer"
                onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                value={brands?.inputValue}
                onChange={(e) => {
                  const newInputValue = e.target.value;
                  if (typeof newInputValue === "string" && newInputValue?.length >= 3) {
                    setSearch(newInputValue);
                  } else {
                    setSearch();
                  }
                }}
                className="cursor-pointer"
                {...brands}
              />
            )}
          />
        </div>
        <div className="relative input">
          <input
            className="input-secondary"
            placeholder="Membership ID"
            readOnly
            value={atcProduct?.pos_membership_product ?? ""}
          />
          <IdentificationIcon className="input-icon w-5 h-5" strokeWidth={1.5} />
        </div>
        <details
          open
          className="bg-white group table-text shadow !mb-4 space-y-4 rounded-[6px] !p-[14px] sm:p-[25px]"
        >
          <summary className="flex items-center justify-between cursor-pointer">
            <span className="text-[16px] font-medium flex">
              Total Items &nbsp;{" "}
              {atcProduct?.products?.reduce((total, product) => total + product.quantity, 0) >
                0 && (
                  <p className="flex-1 border rounded-full px-2">
                    {atcProduct?.products?.reduce((total, product) => total + product.quantity, 0)}
                  </p>
                )}
            </span>
            <div className="flex">
              {atcProduct && atcProduct?.products?.length > 0 && (
                <button
                  className="text-[#C9010E] hover:text-red-800 mr-2 font-medium underline text-sm"
                  onClick={() => setIsClose(true)}
                >
                  Clear Cart
                </button>
              )}
              <span className="transition group-open:rotate-180">
                <ChevronDown className=" w-4 h-5" />
              </span>
            </div>
          </summary>
          <div className={`cart space-y-4 pe-3 ${expand ? "h-full" : "h-[178px]"} overflow-auto`}>
            {sortedData && sortedData?.length > 0 ? (
              <div className="flex items-center justify-end">
                <Tooltip title="Expand product">
                  <ChevronBarExpand
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpand(!expand);
                    }}
                  />
                </Tooltip>
              </div>
            ) : (
              ""
            )}
            {sortedData && sortedData?.length > 0 ? (
              sortedData?.map((elem, index) => {
                return (
                  <div className="cart-card gap-3 flex items-start">
                    <div className="cart-img">
                      <img
                        src={elem?.image || NO_PHOTO}
                        alt={elem?.name}
                        className="inline-block w-full max-h-full object-cover"
                      />
                    </div>
                    <div className="w-full">
                      <div className="flex items-start w-full justify-between">
                        <div>
                          <span className="text-sm inline-block font-medium mb-1">{`${elem?.name?.substring(0, 25)}${elem?.product_name?.length > 25 ? "..." : ""}`}</span>
                          {elem?.group?.length > 0 &&
                            elem?.group?.map((elem, index) => (
                              <p key={index} className="text-sm font-medium mb-1">
                                {elem?.group_name} : {elem?.group_value}
                              </p>
                            ))}
                          {elem?.sku_id && (
                            <div className="flex info-text text-sm items-center gap-4">
                              {/* <p>Size : L</p> */}
                              <p>SKU ID : {elem?.sku_id}</p>
                            </div>
                          )}
                        </div>
                        <button
                          className="inline-flex w-[30px] border border-transparent transition-all duration-200 hover:border-[#C9010E] items-center justify-center h-[30px] bg-[#C9010E1A] rounded-full"
                          onClick={() => removeATCProduct(elem?.product, elem?.variant)}
                        >
                          <TrashIcon className="w-4 h-4 text-[#C9010E]" />
                        </button>
                      </div>
                      <div className="flex items-center mt-1 justify-between">
                        <span className="inline-block text-sm font-semibold">
                          {FormatAmount(elem?.product_total, staffInfo?.client)}
                        </span>
                        {/* <span className='inline-block text-sm font-semibold'>{FormatAmount((elem?.selling_price - (elem?.discount_amount || 0)), staffInfo?.client)}</span> */}
                        <div className="counter">
                          <button
                            type="button"
                            disabled={elem?.quantity <= 1}
                            className={`counter-btn ${elem?.quantity <= 1 && "cursor-not-allowed opacity-50"}`}
                            onClick={() => qtyCounter(elem, false)}
                          >
                            <MinusIcon className="w-3 h-3" />{" "}
                          </button>
                          <input
                            type="number"
                            className="no-arrows"
                            value={elem?.quantity}
                            readOnly
                          // disabled={elem?.quantity >= elem?.total_quantity}
                          // onChange={(e) => updateProductQuantity(elem, Number(e.target.value))}
                          />
                          <button
                            type="button"
                            disabled={elem?.quantity >= elem?.total_quantity}
                            className={`counter-btn ${elem?.quantity >= elem?.total_quantity && "cursor-not-allowed opacity-50"}`}
                            onClick={() => qtyCounter(elem, true)}
                          >
                            <PlusIcon className="w-3 h-3" />{" "}
                          </button>
                        </div>
                      </div>
                      {elem?.discount_amount > 0 && (
                        <span className="inline-block text-xs font-semibold">{`Upto ${FormatAmount(elem?.discount_amount, staffInfo?.client)} off on ${elem?.quantity} or more quantity`}</span>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="w-full flex items-center justify-center table-text h-[168px] secondary-bg-color text-center border main-border-color mb-2.5 rounded-[6px] p-5">
                Cart is empty
              </div>
            )}
          </div>
        </details>
        <span className="text-[16px] font-medium !mt-2">Discounts</span>
        <div className="gap-1 promo-discount">
          <Autocomplete
            className="autocomplete w-full"
            options={discountData}
            getOptionLabel={(options) => options?.coupon_code}
            disabled={!selectCustomer || atcProduct?.products?.length === 0}
            value={
              allDiscount?.data?.records?.find((x) => x.coupon_code === atcProduct?.coupon_code) ||
              null
            }
            onChange={handleDiscount}
            renderInput={(brands) => (
              <TextField
                placeholder="Select Coupon"
                onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                value={brands?.inputValue}
                onChange={(e) => {
                  const newInputValue = e.target.value;
                  if (typeof newInputValue === "string" && newInputValue?.length >= 3) {
                    setCouponSearch(newInputValue);
                  } else {
                    setCouponSearch();
                  }
                }}
                className="cursor-pointer"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                  },
                }}
                {...brands}
              />
            )}
            renderOption={(props, option) => (
              <Box key={option.code} component="li" {...props}>
                <div>
                  <p className="text-sm">{option.coupon_code}</p>
                  <p className="text-sm">{`Flat ${option?.discount} ${option?.discount_Type === "percentage" ? "%" : GetCurrencySymbol(staffInfo?.client)} off`}</p>
                </div>
              </Box>
            )}
          />
          <button
            className={`${!selectCustomer || atcProduct?.products?.length === 0 || atcProduct?.total_discount > 0 ? "cursor-not-allowed opacity-50" : "cursor-pointer"} flex items-center justify-center px-1 py-1.5 w-[125px] h-[30px] text-nowrap bg-[#1E8471] rounded-3xl`}
            disabled={
              !selectCustomer ||
              atcProduct?.products?.length === 0 ||
              atcProduct?.total_discount > 0
            }
            onClick={() => dispatch(applyDiscount(selectCustomer, selectCoupon))}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="white"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.99 14.993 6-6m6 3.001c0 1.268-.63 2.39-1.593 3.069a3.746 3.746 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043 3.745 3.745 0 0 1-3.068 1.593c-1.268 0-2.39-.63-3.068-1.593a3.745 3.745 0 0 1-3.296-1.043 3.746 3.746 0 0 1-1.043-3.297 3.746 3.746 0 0 1-1.593-3.068c0-1.268.63-2.39 1.593-3.068a3.746 3.746 0 0 1 1.043-3.297 3.745 3.745 0 0 1 3.296-1.042 3.745 3.745 0 0 1 3.068-1.594c1.268 0 2.39.63 3.068 1.593a3.745 3.745 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.297 3.746 3.746 0 0 1 1.593 3.068ZM9.74 9.743h.008v.007H9.74v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
              />
            </svg>
            <span className="font-semibold text-xs text-white">Apply Code</span>
          </button>
        </div>
        <div className="flex items-center">
          <div className="relative">
            <select
              value={discountType}
              className="discount-select"
              onChange={handleDiscountType}
              name="discount_Type"
            >
              <option value={"amount"}>{GetCurrencySymbol(staffInfo?.client)}</option>
              <option value={"percentage"}>%</option>
            </select>
            <div className="select-arrow"></div>
          </div>
          <input
            type="number"
            className="ml-1"
            placeholder="Discount Off"
            value={adjustDiscount}
            onChange={discountOff}
          />
        </div>
        <span className="text-[16px] block font-medium">Order Summary</span>
        <div className="bg-secondary p-5 rounded-[10px]">
          <div className="space-y-1 5">
            {/* <div className='flex items-center justify-between'>
                            <span className='info-text font-medium'>Items</span>
                            <span className='font-semibold'>{atcProduct?.products?.reduce((total, product) => total + product.quantity, 0)} Items</span>
                        </div> */}
            <div className="flex items-center justify-between">
              <span className="info-text font-medium">Sub Total</span>
              <span className="font-semibold">
                {FormatAmount(atcProduct?.sub_total, staffInfo?.client)}
              </span>
            </div>
            {atcProduct?.pos_membership_discount > 0 && (
              <div className="flex items-center justify-between">
                <span className="info-text font-medium">Membership Discount</span>
                <span className="font-semibold">
                  - {FormatAmount(atcProduct?.pos_membership_discount, staffInfo?.client)}
                </span>
              </div>
            )}
            {atcProduct?.total_discount > 0 && (
              <div className="flex items-center discount-text justify-between">
                <span className="font-medium">Discount Applied</span>
                <span className="font-semibold">
                  - {FormatAmount(atcProduct?.total_discount, staffInfo?.client)}
                </span>
              </div>
            )}
            {atcProduct?.adjust_discount > 0 && (
              <div className="flex items-center discount-text justify-between">
                <span className="font-medium">Adjust Discount</span>
                <span className="font-semibold">
                  - {FormatAmount(atcProduct?.adjust_discount, staffInfo?.client)}
                </span>
              </div>
            )}
            {/* <div className='flex items-center error-text justify-between'>
                            <span className='font-medium'>Tax (10%)</span>
                            <span className='font-semibold'>+ 0</span>
                        </div> */}
          </div>
          <hr className="border border-dashed my-3 border-color border-5" />
          <div className="flex items-center justify-between">
            <span className="font-medium info-text">TOTAL</span>
            <span className="font-semibold">
              {FormatAmount(atcProduct?.total_price, staffInfo?.client)}
            </span>
          </div>
        </div>
        <div className="text-primary font-medium block text-center">
          <button
            type="button"
            className={`${atcProduct?.products?.length === 0 || !atcProduct?.pos_customer ? "cursor-not-allowed opacity-50" : "cursor-pointer"} underline text-base`}
            disabled={atcProduct?.products?.length === 0 || !atcProduct?.pos_customer}
            onClick={orderPanding}
          >
            Save order to draft
          </button>
        </div>
        <button
          type="button"
          className={`${atcProduct?.products?.length === 0 || !atcProduct?.pos_customer ? "!cursor-not-allowed !opacity-50" : "cursor-pointer"} success-btn`}
          disabled={atcProduct?.products?.length === 0 || !atcProduct?.pos_customer}
          onClick={payNow}
        >
          Pay Now
        </button>
      </div>
      <Popup
        showPopup={isClose}
        closePopup={closePopupClearCart}
        callComponant={
          <ConfirmationPopUp
            heading="Clear Cart"
            subHeading="Are you sure you want to clear cart ?"
            runFunction={runFunctionClearCart}
            closePopup={closePopupClearCart}
            logout={true}
          />
        }
        closebtn={true}
      />
      <Popup
        showPopup={isPaymentDetail}
        closePopup={handleClosePopup}
        callComponant={
          <PaymentDetails
            handleClosePopup={handleClosePopup}
            isSuccess={isSuccess}
            setIsSuccess={setIsSuccess}
          />
        }
        closebtn={true}
      />
      <Popup
        showPopup={openCustomerPopup}
        closePopup={closeCustomerPopup}
        callComponant={<AddCustomer setOpenCustomerPopup={setOpenCustomerPopup} />}
        closebtn={true}
      />
      <Popup
        showPopup={openCustPopup}
        closePopup={closeCustPopup}
        callComponant={<EditCustomer editData={editData} setOpenCustPopup={setOpenCustPopup} />}
        closebtn={true}
      />
    </>
  );
};

export default OrderDetails;
